import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { ServicesGrid } from "@/components/ServicesGrid";
import { About } from "@/components/About";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { Testimonials } from "@/components/Testimonials";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { LiveChatTeaser, FloatingWhatsApp } from "@/components/LiveChatTeaser";
import { useSEO } from "@/hooks/useSEO";
import { SITE_URL, CONTACT_INFO } from "@/data/content";

export default function Home() {
  const location = useLocation();

  useSEO({
    title: "GrowthSync Solutions | Marketing & BPO Company in Dhaka, Bangladesh",
    description:
      "GrowthSync Solutions is a full-service marketing & BPO company in Dhaka, Bangladesh offering telemarketing, lead generation, AI-driven marketing, SEO, software development, and more.",
    canonical: `${SITE_URL}/`,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "GrowthSync Solutions",
      url: SITE_URL,
      email: CONTACT_INFO.email,
      telephone: CONTACT_INFO.phoneRaw,
      address: {
        "@type": "PostalAddress",
        streetAddress: "House# 789, Road# 11, Avenue# 4, Mirpur DOHS, Mirpur",
        addressLocality: "Dhaka",
        postalCode: "1216",
        addressCountry: "BD",
      },
      slogan: "Strategize. Connect. Grow.",
    },
  });

  // Handle cross-page navigation scroll (from service pages / navbar)
  useEffect(() => {
    if (location.state?.scrollTo) {
      const target = location.state.scrollTo;
      setTimeout(() => {
        const el = document.querySelector(target);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 150);
    }
  }, [location.state]);

  return (
    <div className="relative min-h-screen" style={{ backgroundColor: "var(--gs-navy-900)" }}>
      <Navbar />
      <main>
        <Hero />
        <ServicesGrid />
        <About />
        <WhyChooseUs />
        <Testimonials />
        <ContactSection initialService={location.state?.service} />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <LiveChatTeaser />
    </div>
  );
}
